import MyselfService from 'services/MyselfService';
import changeEquipped from './changeEquipped';

const service = new MyselfService();

/** ----------------------------------------------------------------------------
 * EQUIP QUALITY
 -----------------------------------------------------------------------------*/

export default function equipQuality(qualityId: number) {
  return changeEquipped(service.equipQuality)(qualityId);
}